module.exports = __webpack_public_path__ + "img/planeta_volver.140f90b0.png";